export default __webpack_public_path__ + "static/3-416d73017275ae22e72319ba63f18342.jpg";